// Logique PURE de la page tarifs (partagée web/mobile dans l'esprit).
// L'API /api/pricing/plans est la source de vérité ; ce module ne fait que
// dériver l'affichage (tri, mise en avant, comparaison au palier courant).

// Sépare la grille à l'usage en payant / gratuit.
export function splitUsage(usage) {
  const list = Array.isArray(usage) ? usage : [];
  return {
    paid: list.filter((u) => Number(u.credits) > 0),
    free: list.filter((u) => !Number(u.credits)),
  };
}

// Pack offrant le meilleur prix au crédit.
export function bestPack(packs) {
  const list = (Array.isArray(packs) ? packs : []).filter((p) => p.pricePerCredit > 0);
  if (!list.length) return null;
  return list.reduce((best, p) => (p.pricePerCredit < best.pricePerCredit ? p : best), list[0]);
}

// Économie réalisée par rapport au pack le plus cher, en pourcentage.
export function savingsPct(pack, packs) {
  const list = (Array.isArray(packs) ? packs : []).filter((p) => p.pricePerCredit > 0);
  if (!pack || !list.length) return 0;
  const worst = list.reduce((w, p) => (p.pricePerCredit > w.pricePerCredit ? p : w), list[0]);
  if (!worst.pricePerCredit || worst.pricePerCredit === pack.pricePerCredit) return 0;
  return Math.round((1 - pack.pricePerCredit / worst.pricePerCredit) * 100);
}

const RANK = { free: 0, creator: 1, growth: 2, scale: 3 };

// Position d'un palier vis-à-vis du palier courant.
export function planRelation(planId, currentId) {
  const a = RANK[planId], b = RANK[currentId];
  if (a === undefined || b === undefined) return "other";
  if (a === b) return "current";
  return a > b ? "upgrade" : "downgrade";
}

// Libellé du bouton d'action d'une carte de palier.
export function planCtaLabel(planId, currentId) {
  const rel = planRelation(planId, currentId);
  if (rel === "current") return "Palier actuel";
  if (rel === "downgrade") return "Rétrograder";
  return planId === "free" ? "Commencer" : "Passer à ce palier";
}

// Palier recommandé : le premier qui couvre le besoin mensuel en vidéos.
export function recommendedPlan(plans, videosPerMonth) {
  const list = Array.isArray(plans) ? plans : [];
  const need = Math.max(0, Number(videosPerMonth) || 0);
  const sorted = [...list].sort((a, b) => (a.priceEur || 0) - (b.priceEur || 0));
  return sorted.find((p) => (p.yield?.videos ?? p.monthlyCredits ?? 0) >= need) || sorted[sorted.length - 1] || null;
}

// Coût d'un besoin mensuel exprimé en crédits (vidéos + images).
export function monthlyNeed(videos, images) {
  const v = Math.max(0, Number(videos) || 0);
  const i = Math.max(0, Number(images) || 0);
  return Math.round((v * 1 + i * 0.1) * 100) / 100;
}

// Le palier couvre-t-il le besoin ?
export const planCovers = (plan, credits) =>
  (plan?.monthlyCredits ?? 0) + 1e-9 >= (Number(credits) || 0);

// Accord en nombre — « 1 vidéo » et non « 1 vidéos ».
export const plural = (n, singulier, pluriel) =>
  `${n} ${Math.abs(Number(n) || 0) > 1 ? (pluriel || singulier + "s") : singulier}`;

// « 25 vidéos ou 250 images » — rendu d'un quota (plan ou pack).
export function yieldText(y) {
  if (!y) return "";
  return `${plural(y.videos, "vidéo")} ou ${plural(y.images, "image")}`;
}
